import { PERMISSION_KEYS, FEATURE_FLAGS, UI_LABELS, buildTemplateKey } from '../constants';

// Static permission groups (parent + children)
export const STATIC_PERMISSIONS = {
  // Manage Relationships
  relationships: {
    id: 'relationships',
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_RELATIONSHIPS,
    label: UI_LABELS.MANAGE_RELATIONSHIPS,
    type: 'group',
    children: [
      { id: PERMISSION_KEYS.RELATIONSHIPS.SEND_B2B_REQUEST, label: UI_LABELS.SEND_B2B_REQUEST },
      { id: PERMISSION_KEYS.RELATIONSHIPS.ACCEPT_REJECT_B2B_REQUEST, label: UI_LABELS.ACCEPT_REJECT_B2B_REQUEST },
      { id: PERMISSION_KEYS.RELATIONSHIPS.MANAGE_CONTRACTS, label: UI_LABELS.MANAGE_CONTRACTS },
      { id: PERMISSION_KEYS.RELATIONSHIPS.DEASSOCIATE_B2B_RELATIONSHIP, label: UI_LABELS.DEASSOCIATE_B2B_RELATIONSHIP },
      { id: PERMISSION_KEYS.RELATIONSHIPS.ADD_REMOVE_EXCLUDE_LIST, label: UI_LABELS.ADD_REMOVE_EXCLUDE_LIST },
      { id: PERMISSION_KEYS.RELATIONSHIPS.VIEW_B2B_WORKLOAD, label: UI_LABELS.VIEW_B2B_WORKLOAD },
    ]
  },

  // Manage Users
  users: {
    id: 'users',
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_USERS,
    label: UI_LABELS.MANAGE_USERS,
    type: 'group',
    children: [
      { id: PERMISSION_KEYS.USERS.REASSIGN_USER, label: UI_LABELS.REASSIGN_USER },
      { id: PERMISSION_KEYS.USERS.EDIT_USER, label: UI_LABELS.EDIT_USER },
      { id: PERMISSION_KEYS.USERS.BLOCK_USER, label: UI_LABELS.BLOCK_USER },
      { id: PERMISSION_KEYS.USERS.ADD_USER, label: UI_LABELS.ADD_USER },
      { id: PERMISSION_KEYS.USERS.RESET_PASSWORD, label: UI_LABELS.RESET_PASSWORD },
      { id: PERMISSION_KEYS.USERS.ADD_WATCHERS, label: UI_LABELS.ADD_WATCHERS },
      { id: PERMISSION_KEYS.USERS.ACT_AS_HIDDEN_WATCHER, label: UI_LABELS.ACT_AS_HIDDEN_WATCHER },
      { id: PERMISSION_KEYS.USERS.VIEW_WORKLOAD, label: UI_LABELS.VIEW_WORKLOAD },
    ]
  },

  // Manage Workkards
  workkards: {
    id: 'workkards',
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_WORKKARDS,
    label: UI_LABELS.MANAGE_WORKKARDS,
    type: 'group',
    isDynamic: true,
    module: 'Workkard',
    children: [
      { id: PERMISSION_KEYS.WORKKARDS.CREATE_WORKKARD, label: UI_LABELS.CREATE_WORKKARD, hasTemplate: true },
      { id: PERMISSION_KEYS.WORKKARDS.CHANGE_WORKKARD_SPONSOR, label: UI_LABELS.CHANGE_WORKKARD_SPONSOR },
      { id: PERMISSION_KEYS.WORKKARDS.ARCHIVE_WORKKARD, label: UI_LABELS.ARCHIVE_WORKKARD },
      { id: PERMISSION_KEYS.WORKKARDS.RECEIVE_UNASSIGNED_WORKKARDS, label: UI_LABELS.RECEIVE_UNASSIGNED_WORKKARDS },
      { id: PERMISSION_KEYS.WORKKARDS.CLOSE_WORKKARD, label: UI_LABELS.CLOSE_WORKKARD, featureFlag: FEATURE_FLAGS.CLOSE_WORKKARD },
      { id: PERMISSION_KEYS.WORKKARDS.EDIT_WORKKARD, label: UI_LABELS.EDIT_WORKKARD },
      { id: PERMISSION_KEYS.WORKKARDS.EDIT_CLOSED_WORKKARD, label: UI_LABELS.EDIT_CLOSED_WORKKARD },
      { id: PERMISSION_KEYS.WORKKARDS.REOPEN_WORKKARD, label: UI_LABELS.REOPEN_WORKKARD },
    ]
  },

  // Manage Activity
  activity: {
    id: 'activity',
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_ACTIVITY,
    label: UI_LABELS.MANAGE_ACTIVITY,
    type: 'group',
    isDynamic: true,
    module: 'Activity',
    children: [
      { id: PERMISSION_KEYS.ACTIVITY.CREATE_ACTIVITY, label: UI_LABELS.CREATE_ACTIVITY, hasTemplate: true },
      { id: PERMISSION_KEYS.ACTIVITY.REOPEN_ACTIVITY, label: UI_LABELS.REOPEN_ACTIVITY },
      { id: PERMISSION_KEYS.ACTIVITY.CLOSE_ACTIVITY, label: UI_LABELS.CLOSE_ACTIVITY },
      { id: PERMISSION_KEYS.ACTIVITY.ACCEPT_REJECT_ACTIVITY, label: UI_LABELS.ACCEPT_REJECT_ACTIVITY },
      { id: PERMISSION_KEYS.ACTIVITY.ARCHIVE_ACTIVITY, label: UI_LABELS.ARCHIVE_ACTIVITY },
      { id: PERMISSION_KEYS.ACTIVITY.ACCEPT_REJECT_BID, label: UI_LABELS.ACCEPT_REJECT_BID },
      { id: PERMISSION_KEYS.ACTIVITY.REASSIGN_ACTIVITY, label: UI_LABELS.REASSIGN_ACTIVITY },
      { id: PERMISSION_KEYS.ACTIVITY.RECEIVE_UNASSIGNED_ACTIVITIES, label: UI_LABELS.RECEIVE_UNASSIGNED_ACTIVITIES },
      { id: PERMISSION_KEYS.ACTIVITY.CHANGE_ACTIVITY_OWNER, label: UI_LABELS.CHANGE_ACTIVITY_OWNER },
      { id: PERMISSION_KEYS.ACTIVITY.MARK_ACTIVITY_IN_PROGRESS, label: UI_LABELS.MARK_ACTIVITY_IN_PROGRESS },
      { id: PERMISSION_KEYS.ACTIVITY.COMPLETE_ACTIVITY, label: UI_LABELS.COMPLETE_ACTIVITY },
      { id: PERMISSION_KEYS.ACTIVITY.CLOSE_ACTIVITY_MIDTERM, label: UI_LABELS.CLOSE_ACTIVITY_MIDTERM },
      { id: PERMISSION_KEYS.ACTIVITY.ASSIGN_B2B, label: UI_LABELS.ASSIGN_B2B },
      { id: PERMISSION_KEYS.ACTIVITY.EDIT_ACTIVITY, label: UI_LABELS.EDIT_ACTIVITY },
    ]
  },

  // Manage Notes - with sub-groups
  notes: {
    id: 'notes',
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_NOTES,
    label: UI_LABELS.MANAGE_NOTES,
    type: 'group',
    children: [
      {
        id: PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES,
        label: UI_LABELS.MANAGE_WORKKARD_NOTES,
        type: 'subgroup',
        children: [
          { id: PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES_PUBLIC, label: UI_LABELS.MANAGE_WORKKARD_NOTES_PUBLIC },
          { id: PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES_PRIVATE, label: UI_LABELS.MANAGE_WORKKARD_NOTES_PRIVATE },
        ]
      },
      {
        id: PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES,
        label: UI_LABELS.MANAGE_ACTIVITY_NOTES,
        type: 'subgroup',
        children: [
          { id: PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES_PUBLIC, label: UI_LABELS.MANAGE_ACTIVITY_NOTES_PUBLIC },
          { id: PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES_PRIVATE, label: UI_LABELS.MANAGE_ACTIVITY_NOTES_PRIVATE },
        ]
      },
      { id: PERMISSION_KEYS.NOTES.DELETE_UPDATE_NOTES_TIMEFRAME, label: UI_LABELS.DELETE_UPDATE_NOTES_TIMEFRAME },
      { id: PERMISSION_KEYS.NOTES.CLONE_NOTES, label: UI_LABELS.CLONE_NOTES },
    ]
  },

  // Manage Views
  views: {
    id: 'views',
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_REPORTS,
    label: UI_LABELS.MANAGE_REPORTS,
    type: 'group',
    children: [
      { id: PERMISSION_KEYS.REPORTS.ADD_MATRIX_REPORT, label: UI_LABELS.ADD_MATRIX_REPORT },
      { id: PERMISSION_KEYS.REPORTS.CLOSE_ACTIVITY_IN_VIEWS, label: UI_LABELS.CLOSE_ACTIVITY_IN_VIEWS, featureFlag: FEATURE_FLAGS.COMPLETE_DIARY },
      { id: PERMISSION_KEYS.REPORTS.COMPLETE_DIARY_IN_VIEWS, label: UI_LABELS.COMPLETE_DIARY_IN_VIEWS, featureFlag: FEATURE_FLAGS.COMPLETE_DIARY },
      { id: PERMISSION_KEYS.REPORTS.APPLY_AGGREGATION_IN_VIEWS, label: UI_LABELS.APPLY_AGGREGATION_IN_VIEWS, featureFlag: FEATURE_FLAGS.AGGREGATION_VIEWS },
    ]
  },

  // Manage Diary
  diary: {
    id: 'diary',
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_TODOS,
    label: UI_LABELS.MANAGE_TODOS,
    type: 'group',
    children: [
      { id: PERMISSION_KEYS.TODOS.CREATE_DIARY, label: UI_LABELS.CREATE_DIARY },
      { id: PERMISSION_KEYS.TODOS.EDIT_OWN_DIARY, label: UI_LABELS.EDIT_OWN_DIARY },
      { id: PERMISSION_KEYS.TODOS.EDIT_TODO, label: UI_LABELS.EDIT_TODO },
      { id: PERMISSION_KEYS.TODOS.DELETE_TODO, label: UI_LABELS.DELETE_TODO },
      { id: PERMISSION_KEYS.TODOS.COMPLETE_REOPEN_DIARY, label: UI_LABELS.COMPLETE_REOPEN_DIARY, featureFlag: FEATURE_FLAGS.COMPLETE_DIARY },
    ]
  },

  // Manage Parties
  parties: {
    id: 'parties',
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_PARTIES,
    label: UI_LABELS.MANAGE_PARTIES,
    type: 'group',
    featureFlag: FEATURE_FLAGS.ASSOCIATED_PARTY,
    children: [
      { id: PERMISSION_KEYS.PARTIES.CREATE_PARTY, label: UI_LABELS.CREATE_PARTY },
      { id: PERMISSION_KEYS.PARTIES.DELETE_PARTY, label: UI_LABELS.DELETE_PARTY },
    ]
  },
};

// Single permissions (standalone header bars)
export const SINGLE_PERMISSIONS = [
  { id: PERMISSION_KEYS.SINGLE.MANAGE_COMPANY_PROFILE, label: UI_LABELS.MANAGE_COMPANY_PROFILE, type: 'single' },
  { id: PERMISSION_KEYS.SINGLE.MANAGE_SETTINGS, label: UI_LABELS.MANAGE_SETTINGS, type: 'single' },
  { id: PERMISSION_KEYS.SINGLE.INVITE_USER_TO_COMMUNITY, label: UI_LABELS.INVITE_USER_TO_COMMUNITY, type: 'single' },
  { id: PERMISSION_KEYS.SINGLE.MANAGE_RULES, label: UI_LABELS.MANAGE_RULES, type: 'single', featureFlag: FEATURE_FLAGS.RULE_ENGINE },
  { id: PERMISSION_KEYS.SINGLE.MANAGE_ATLAS, label: UI_LABELS.MANAGE_ATLAS, type: 'single', featureFlag: FEATURE_FLAGS.ATLAS },
];

// Single permissions that appear AFTER mercury
export const SINGLE_PERMISSIONS_AFTER_MERCURY = [
  { id: PERMISSION_KEYS.SINGLE.CONNECT_MAILBOT, label: UI_LABELS.CONNECT_MAILBOT, type: 'single', featureFlag: FEATURE_FLAGS.MAILBOT_PERMISSION },
  { id: PERMISSION_KEYS.SINGLE.MANAGE_COMMUNICATION, label: UI_LABELS.MANAGE_COMMUNICATION, type: 'single', featureFlag: FEATURE_FLAGS.COMMUNICATION },
];

// Single permission that appears AFTER inbox
export const SINGLE_PERMISSIONS_AFTER_INBOX = [
  { id: PERMISSION_KEYS.SINGLE.ACCESS_BULK_INBOX, label: UI_LABELS.ACCESS_BULK_INBOX, type: 'single' },
];

export const processDynamicPermissions = (currentUser) => {
  const dynamicPermissions = {};

  if (!currentUser?.permissions) return dynamicPermissions;

  // Mercury Permissions
  if (currentUser.permissions.mercury) {
    dynamicPermissions.mercury = {
      id: 'mercury',
      parentKey: 'can_access_mercury',
      label: 'Can Access Mercury',
      type: 'dynamic-group',
      featureFlag: FEATURE_FLAGS.MERCURY,
      children: (currentUser.permissions.mercury.permissions || []).map(perm => ({
        id: perm.key,
        label: perm.name,
      }))
    };
  }

  // Inbox Permissions
  if (currentUser.permissions.inbox) {
    dynamicPermissions.inbox = {
      id: 'inbox',
      parentKey: 'can_access_inbox',
      label: 'Can Access Inbox',
      type: 'dynamic-group',
      children: (currentUser.permissions.inbox.permissions || []).map(perm => ({
        id: perm.key,
        label: perm.name,
      }))
    };
  }

  // Financial Permissions
  if (currentUser.permissions.financials) {
    dynamicPermissions.financials = {
      id: 'financials',
      parentKey: 'can_access_financials',
      label: 'Can Access Financials',
      type: 'dynamic-sectioned',
      sections: (currentUser.permissions.financials.permissions || []).map(section => ({
        id: section.section_name,
        label: section?.section_name?.charAt(0).toUpperCase() + section?.section_name?.slice(1),
          permissions: (section.permissions || []).map(perm => ({
            id: perm.key,
            label: perm.name,
            options: perm.options ? perm.options.map(opt => ({
              id: opt.key,
              label: opt.name,
            })) : null,
          }))
      }))
    };
  }

  // Review System Permissions
  if (currentUser.permissions.review_system) {
    dynamicPermissions.reviewSystem = {
      id: 'reviewSystem',
      parentKey: 'can_access_review_system',
      label: 'Can Access Review System',
      type: 'dynamic-group',
      children: (currentUser.permissions.review_system.permissions || []).map(perm => ({
        id: perm.key,
        label: perm.name,
      }))
    };
  }

  // Authorized States
  if (currentUser.permissions.authorized_states?.Data?.states?.length > 0) {
    dynamicPermissions.authorizedStates = {
      id: 'authorizedStates',
      parentKey: 'authorized_states',
      label: 'Authorized States',
      type: 'dynamic-group',
      children: currentUser.permissions.authorized_states.Data.states.map(state => ({
          id: `state_${state.state_code}`,
        label: `${state.state_code} (${state.state_name})`,
      }))
    };
  }

  // Letters Permissions
  if (currentUser.permissions.letters) {
    const sections = [];

    // Admin section
    if (currentUser.permissions.letters.admin_permissions?.length > 0) {
      sections.push({
        id: 'admin',
        label: 'Admin',
        permissions: currentUser.permissions.letters.admin_permissions.map(perm => ({
          id: perm.key,
          label: perm.name,
        }))
      });
    }

    // Dashboard section (user_permissions)
    if (currentUser.permissions.letters.user_permissions?.length > 0) {
      sections.push({
        id: 'dashboard',
        label: 'Dashboard',
        permissions: currentUser.permissions.letters.user_permissions.map(perm => ({
          id: perm.key,
          label: perm.name,
          options: perm.options ? perm.options.map(opt => ({
            id: opt.key,
            label: opt.name,
          })) : null,
        }))
      });
    }

    // Request section
    if (currentUser.permissions.letters.can_request) {
      sections.push({
        id: 'request',
        label: 'Request',
        permissions: [
          { id: 'can_request_for_letter', label: 'Can Request Letter' }
        ]
      });
    }

    dynamicPermissions.letters = {
      id: 'letters',
      parentKey: 'can_manage_letters',
      label: 'Manage Letters',
      type: 'dynamic-sectioned',
      featureFlag: FEATURE_FLAGS.LETTER_PERMISSIONS,
      sections
    };
  }

  return dynamicPermissions;
};

export const mergeTemplatesWithPermissions = (templates) => {
  if (!templates || !Array.isArray(templates)) {
    return { ...STATIC_PERMISSIONS };
  }

  const mergedPermissions = JSON.parse(JSON.stringify(STATIC_PERMISSIONS));

  Object.keys(mergedPermissions).forEach(sectionKey => {
    const section = mergedPermissions[sectionKey];
    
    if (section.isDynamic && section.module) {
      const moduleTemplates = templates.filter(t => t.module === section.module);
      
      if (moduleTemplates.length > 0) {
        section.children = section.children.map(child => {
          if (child.hasTemplate) {
            return {
              ...child,
              templates: moduleTemplates.map(t => ({
                id: buildTemplateKey(section.module, t.id),
                name: t.name,
                module: t.module,
              }))
            };
          }
          return child;
        });
      }
    }
  });

  return mergedPermissions;
};

export const getAllPermissions = (currentUser, templates) => {
  const staticWithTemplates = mergeTemplatesWithPermissions(templates);
  const dynamicPermissions = processDynamicPermissions(currentUser);

  // Build ordered array
  const orderedPermissions = [];

  // Static groups
  Object.keys(staticWithTemplates).forEach(key => {
    orderedPermissions.push({ key, ...staticWithTemplates[key] });
  });

  // Single permissions before mercury
  SINGLE_PERMISSIONS.forEach(perm => {
    orderedPermissions.push({ key: perm.id, ...perm });
  });

  // Mercury (dynamic)
  if (dynamicPermissions.mercury) {
    orderedPermissions.push({ key: 'mercury', ...dynamicPermissions.mercury });
  }

  // Singles after mercury
  SINGLE_PERMISSIONS_AFTER_MERCURY.forEach(perm => {
    orderedPermissions.push({ key: perm.id, ...perm });
  });

  // Inbox (dynamic)
  if (dynamicPermissions.inbox) {
    orderedPermissions.push({ key: 'inbox', ...dynamicPermissions.inbox });
  }

  // Singles after inbox
  SINGLE_PERMISSIONS_AFTER_INBOX.forEach(perm => {
    orderedPermissions.push({ key: perm.id, ...perm });
  });

  // Financials (dynamic)
  if (dynamicPermissions.financials) {
    orderedPermissions.push({ key: 'financials', ...dynamicPermissions.financials });
  }

  // Authorized States (dynamic)
  if (dynamicPermissions.authorizedStates) {
    orderedPermissions.push({ key: 'authorizedStates', ...dynamicPermissions.authorizedStates });
  }

  // Letters (dynamic)
  if (dynamicPermissions.letters) {
    orderedPermissions.push({ key: 'letters', ...dynamicPermissions.letters });
  }
  const SHOW_REVIEW_SYSTEM = false;
  if (SHOW_REVIEW_SYSTEM && dynamicPermissions.reviewSystem) {
    orderedPermissions.push({ key: 'reviewSystem', ...dynamicPermissions.reviewSystem });
  }

  return orderedPermissions;
};

export const filterPermissionsByFeatureFlags = (permissions, featureFlags) => {
  return permissions
    .filter(section => {
      if (section.featureFlag && !featureFlags[section.featureFlag]) {
        return false;
      }
      return true;
    })
    .map(section => {
      if (section.children && Array.isArray(section.children)) {
        return {
          ...section,
          children: section.children.filter(child => {
            if (child.featureFlag && !featureFlags[child.featureFlag]) {
              return false;
            }
            return true;
          }),
        };
      }
      return section;
    });
};